﻿import { Mail } from "lucide-react";
import { Trans } from "react-i18next";
import { Link, useSearchParams } from "react-router-dom";

import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useT } from "@/lib/i18n";

export function CheckEmailPage() {
  const t = useT("auth");
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") ?? undefined;

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-muted/40">
      <Card className="w-full max-w-md text-center">
        <CardHeader className="space-y-4">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
            <Mail className="h-7 w-7 text-primary" />
          </div>
          <div className="space-y-2">
            <CardTitle className="text-2xl">{t("checkEmailPage.title")}</CardTitle>
            <CardDescription>
              {email ? (
                <Trans
                  i18nKey="auth.checkEmailPage.description"
                  values={{ email }}
                  components={{ b: <strong /> }}
                />
              ) : (
                t("checkEmailPage.descriptionNoEmail")
              )}
            </CardDescription>
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">{t("checkEmailPage.hint")}</p>
          <Button asChild variant="outline" className="w-full">
            <Link to="/login">{t("backToLogin")}</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
